const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

export const retry = async (load, { attempts, delayMs }) => {
    for (let attempt = 1; ; attempt += 1) {
        try {
            return await load();
        } catch (e) {
            if (attempt >= attempts) throw e;
            await wait(delayMs * attempt);
        }
    }
};
